import React from "react";
import NewsletterFive from "../component/NewsletterFive";

function NewsletterFiveContainers() {
  return <NewsletterFive />;
}

export default NewsletterFiveContainers;
